import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SuffixInputComponent } from './suffix-input.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [SuffixInputComponent],
    declarations: [SuffixInputComponent],
    providers: [],
})
export class SuffixInputModule { }
